// Thư viện khối YouTube cho Tự dựng — selector DÒ THẬT trên Chrome đã đăng nhập (2026-09-21 23:50, giao diện tiếng Việt):
// kết quả tìm kiếm: <ytd-video-renderer> (video thường; playlist là <yt-lockup-view-model>, quảng cáo <ytd-ad-slot-renderer> → không lấy),
// trong đó a#video-title (tiêu đề + href /watch?v=), ytd-channel-name a (kênh), #metadata-line span (lượt xem). Trang video: bình luận CHỈ
// tải khi cuộn tới #comments; ô nhập: bấm #placeholder-area ("Thêm bình luận...") → #contenteditable-root (contenteditable) trong
// <ytd-comment-simplebox-renderer> → #submit-button "Bình luận" (mờ tới khi có chữ). Mỗi bình luận cấp 1 = <ytd-comment-thread-renderer>:
// #author-text (@handle), #content-text, #reply-button-end button "Phản hồi" → mở <ytd-comment-reply-dialog-renderer> NGAY TRONG thread
// với #contenteditable-root + #submit-button "Phản hồi". Video tắt bình luận: #comments có <ytd-message-renderer>, không có #placeholder-area
// → bước bấm ô nhập không tìm thấy → dừng rõ (không bấm bừa).
import type { KhoiMau } from "./tu-dung";
import { themChiBaiLienQuan } from "./chi-lien-quan"; // (05/10) "Chỉ bình luận bài liên quan" co/khong cho mọi khối có bước chấm
import { DK_THICH_LUOT as YT_DK_THICH_LUOT } from "./ti-le-thich"; // tỉ lệ thích = xác suất, biểu thức giữ nguyên chữ — xem tệp đó

export const YT_URL = "https://www.youtube.com/";

export const VIDEO_LIST_SPEC = {
  mode: "list",
  list: { describe: "danh sách video kết quả tìm kiếm YouTube", ladder: [{ t: "css", sel: "ytd-video-renderer" }] },
  fields: {
    tieu_de: { sel: "a#video-title", attr: "text", alt: ["#video-title"], fallback: "longest_text" },
    kenh: { sel: "ytd-channel-name a", attr: "text", alt: ["#channel-name a", "#channel-name"] },
    luot_xem: { sel: "#metadata-line span", attr: "text" },
    lien_ket: { sel: "a#video-title", attr: "href", alt: ["a#thumbnail", 'a[href*="/watch"]'] },
    anh_url: { sel: null, attr: "anh_lon" }, // ảnh bìa video — AI nhìn khi tiêu đề quá ngắn
  },
  item_key: "lien_ket",
};

const COMMENT_LIST_SPEC = {
  mode: "list",
  list: { describe: "danh sách bình luận cấp 1 dưới video", ladder: [{ t: "css", sel: "ytd-comment-thread-renderer" }] },
  fields: {
    nguoi: { sel: "#author-text", attr: "text", alt: ["#author-text span", "#header-author a"] },
    noi_dung: { sel: "#content-text", attr: "text", fallback: "longest_text" },
    thich: { sel: "#vote-count-middle", attr: "text" },
    anh_url: { sel: null, attr: "anh_lon" }, // ảnh kèm bình luận (avatar 40px bị bỏ)
  },
  item_key: "noi_dung",
};

// Cuộn tới khu bình luận: YouTube CHỈ tải bình luận sau cú lăn chuột THẬT (wheel isTrusted) — scrollIntoView từ JS không tải (đăng thật
// 2026-09-22: 0/2 vì không thấy #placeholder-area). Đưa #comments vào khung nhìn rồi lăn thật một cú (chrome.debugger, như TikTok).
const CUON_TOI_BINH_LUAN = { kind: "scroll", target: { describe: "khu bình luận dưới video", ladder: [{ t: "css", sel: "#comments" }, { t: "css", sel: "ytd-comments" }] } };
const LAN_THAT = { kind: "scroll", dy: 300, trusted: true };

// CHỐT ĐÚNG VIDEO trước khi gõ và trước cú bấm gửi (Action.chot — content script kiểm cùng lượt với thao tác): YouTube tự phát video kế (SPA,
// địa chỉ đổi bằng history) — trang đã sang video khác giữa lúc mở ô bình luận và lúc bấm gửi thì bấm là bình luận vào VIDEO KHÁC, hậu kiểm "thấy
// chữ" vẫn đạt (E2E binh-luan-tu-chuyen BT3/BT4 đỏ trên bản cũ). So theo MÃ video (ma_video: v=<id> / /shorts/<id>). Hậu kiểm cũng chốt mã video.
const CHOT_VIDEO = (bienUrl: string) => ({ cond: { t: "url_contains", s: `{{ ma_video(${bienUrl}) }}` }, ly_do: "trang đã tự chuyển sang video khác — không gửi (tránh đăng nhầm vào video khác)" });
const DA_GUI = (bienUrl: string, chu: string) => [{ t: "url_contains", s: `{{ ma_video(${bienUrl}) }}` }, { t: "text_visible", text: chu }];

// Bấm ô "Thêm bình luận..." → gõ → bấm gửi, chốt đúng video `bienUrl` trước khi gõ và trước khi bấm gửi.
const GHI_BINH_LUAN = (bienUrl: string, chu: string) => [
  { kind: "click", target: { describe: "ô 'Thêm bình luận...' (bấm để mở ô nhập)", ladder: [
    { t: "css", sel: "ytd-comment-simplebox-renderer #placeholder-area" },
    { t: "css", sel: "#placeholder-area" },
    { t: "model", prompt: "ô 'Thêm bình luận...' / 'Add a comment...' dưới video — bấm vào để mở ô nhập bình luận" },
  ] } },
  { kind: "type", target: { describe: "ô nhập bình luận", ladder: [
    { t: "css", sel: "ytd-comment-simplebox-renderer #contenteditable-root" },
    { t: "css", sel: '#contenteditable-root[contenteditable="true"]' },
    { t: "model", prompt: "ô nhập bình luận (contenteditable) vừa mở dưới video" },
  ] }, text: chu, chot: CHOT_VIDEO(bienUrl) },
  // #submit-button là <ytd-button-renderer> bọc <button> thật — bấm vào <button> bên trong (bấm lớp bọc không kích hoạt handler).
  { kind: "click", target: { describe: "nút Bình luận (gửi)", ladder: [
    { t: "css", sel: "ytd-comment-simplebox-renderer #submit-button button" },
    { t: "css", sel: "#submit-button button" },
    { t: "model", prompt: "nút 'Bình luận' / 'Comment' để gửi bình luận vừa gõ" },
  ] }, chot: CHOT_VIDEO(bienUrl) },
];

const DANG_ACTIONS = [
  { kind: "navigate", url: "{{item.lien_ket}}" },
  CUON_TOI_BINH_LUAN, LAN_THAT,
  ...GHI_BINH_LUAN("item.lien_ket", "{{item.binh_luan}}"),
];

export const MO_BINH_LUAN_ACTIONS = (url: string) => [{ kind: "navigate", url }, CUON_TOI_BINH_LUAN, LAN_THAT];

const TRA_LOI_ACTIONS = [
  { kind: "click", target: { describe: "nút Phản hồi của bình luận này", within: "item", ladder: [
    { t: "css", sel: "#reply-button-end button" },
    { t: "css", sel: "#reply-button-end" },
    { t: "model", prompt: "nút 'Phản hồi' / 'Reply' của bình luận đang xét" },
  ] } },
  { kind: "type", target: { describe: "ô nhập trả lời", within: "item", ladder: [
    { t: "css", sel: "ytd-comment-reply-dialog-renderer #contenteditable-root" },
    { t: "css", sel: '#contenteditable-root[contenteditable="true"]' },
    { t: "model", prompt: "ô nhập trả lời (contenteditable) vừa mở dưới bình luận đang xét" },
  ] }, text: "{{item.tra_loi}}", chot: CHOT_VIDEO("video_url") },
  { kind: "click", target: { describe: "nút Phản hồi (gửi)", within: "item", ladder: [
    { t: "css", sel: "ytd-comment-reply-dialog-renderer #submit-button button" },
    { t: "css", sel: "#submit-button button" },
    { t: "model", prompt: "nút 'Phản hồi' / 'Reply' để gửi câu trả lời vừa gõ" },
  ] }, chot: CHOT_VIDEO("video_url") },
];

// Hội đồng: một bình luận cụ thể = ytd-comment-thread-renderer có #content-text chứa chữ (bản đồ dò thật: mỗi luồng có
// #like-button và #reply-button-end riêng). Tìm theo chữ vì YouTube không cho lấy địa chỉ riêng của bình luận một cách chắc chắn.
const YT_LUONG = '//ytd-comment-thread-renderer[.//*[@id="content-text"][contains(normalize-space(.), {{ xpath_chu(chu_binh_luan) }})]]';
const YT_THICH_ACTIONS = [
  ...MO_BINH_LUAN_ACTIONS("{{bai_url}}"),
  { kind: "click", target: { describe: "nút Thích của bình luận chứa chữ đã cho", ladder: [
    { t: "xpath", xpath: `(${YT_LUONG}//*[@id="like-button"]//button)[1]` },
    { t: "xpath", xpath: `(${YT_LUONG}//*[@id="like-button"])[1]` },
    { t: "model", prompt: "nút Thích (ngón cái) nằm trong bình luận chứa chữ {{chu_binh_luan}} — không phải nút Thích video" },
  ] } },
];
const YT_TRA_LOI_MOT_ACTIONS = [
  ...MO_BINH_LUAN_ACTIONS("{{bai_url}}"),
  { kind: "click", target: { describe: "nút Phản hồi của bình luận chứa chữ đã cho", ladder: [
    { t: "xpath", xpath: `(${YT_LUONG}//*[@id="reply-button-end"]//button)[1]` },
    { t: "xpath", xpath: `(${YT_LUONG}//*[@id="reply-button-end"])[1]` },
    { t: "model", prompt: "nút Phản hồi của bình luận chứa chữ {{chu_binh_luan}}" },
  ] } },
  { kind: "type", target: { describe: "ô trả lời vừa mở dưới bình luận đó", ladder: [
    { t: "xpath", xpath: `(${YT_LUONG}//ytd-comment-reply-dialog-renderer//*[@id="contenteditable-root"])[1]` },
    { t: "css", sel: "ytd-comment-reply-dialog-renderer #contenteditable-root" },
    { t: "model", prompt: "ô nhập trả lời vừa mở dưới bình luận chứa chữ {{chu_binh_luan}}" },
  ] }, text: "{{cau_tra_loi}}", chot: CHOT_VIDEO("bai_url") },
  { kind: "click", target: { describe: "nút gửi trả lời", ladder: [
    { t: "xpath", xpath: `(${YT_LUONG}//ytd-comment-reply-dialog-renderer//*[@id="submit-button"]//button)[1]` },
    { t: "css", sel: "ytd-comment-reply-dialog-renderer #submit-button button" },
    { t: "model", prompt: "nút Phản hồi để gửi câu trả lời vừa gõ" },
  ] }, chot: CHOT_VIDEO("bai_url") },
];
const YT_BINH_LUAN_MOT_ACTIONS = [...MO_BINH_LUAN_ACTIONS("{{bai_url}}"), ...GHI_BINH_LUAN("bai_url", "{{binh_luan}}")];

// ===================== YouTube — THAO TÁC NHƯ NGƯỜI (2026-10-01): xem, thích, lướt =====================
// Đo thật Edge #2 (2026-10-01, kênh @hoc11admin68, CHỈ đọc DOM). Trang xem /watch: nút Thích VIDEO = ytd-watch-metadata #actions-inner
// segmented-like-dislike-button-view-model like-button-view-model button, aria-pressed, aria-label "cùng N người khác thích video này". Trang có
// 5 like-button-view-model (bản ẩn trong #menu-container, nút nhanh trong trình phát, "Thích bản tóm tắt này" của phần AI tóm tắt) → phải chỉ ĐÚNG
// khung #actions-inner. Shorts /shorts/<id>: ytd-shorts reel-action-bar-view-model like-button-view-model button; sang Short kế = #navigation-button-down
// button ("Video tiếp theo"). Chỉ nhắm aria-pressed="false" (đã thích mà bấm nữa = BỎ thích), không nấc "model".
// Cửa sổ KHÔNG có tiêu điểm thì video không tự phát (#movie_player "unstarted-mode", nút Phát "Phát (k)") — xem_video hiện chỉ Ở LẠI trang N giây;
// bấm Phát chưa làm vì chưa kiểm được trên trang thật (không được bấm khi đọc) và bấm nhầm lúc đang phát là Tạm dừng — đề xuất làm sau.
const YT_NUT_THICH = "ytd-watch-metadata #actions-inner segmented-like-dislike-button-view-model like-button-view-model button";
const YT_NUT_THICH_SHORTS = "ytd-shorts reel-action-bar-view-model like-button-view-model button";
const YT_THICH = { kind: "click", target: { describe: "nút Thích video (ngón cái) — chỉ khi CHƯA thích", ladder: [
  { t: "css", sel: `${YT_NUT_THICH}[aria-pressed="false"]` },
  { t: "css", sel: `${YT_NUT_THICH_SHORTS}[aria-pressed="false"]` },
] } };
const YT_DA_THICH = [{ t: "locator_visible", target: { describe: "nút Thích video ở trạng thái đã bấm", ladder: [
  { t: "css", sel: `${YT_NUT_THICH}[aria-pressed="true"]` },
  { t: "css", sel: `${YT_NUT_THICH_SHORTS}[aria-pressed="true"]` },
] } }];
const YT_CO_TRINH_PHAT = { t: "dom_exists", sel: "#movie_player, #shorts-player" };
const YT_TS_TI_LE_THICH = { ten: "ti_le_thich", moTa: "phần trăm video được bấm Thích khi lướt (0-30; 0 = chỉ xem, không thích)", kieu: "so" as const, min: 0, max: 30, macDinh: "10" };
const YT_TS_GIAY_XEM = { ten: "giay_xem", moTa: "số giây ở lại xem mỗi video trước khi làm việc khác (3-600)", kieu: "so" as const, min: 3, max: 600, macDinh: "30" };

// ===================== YouTube — TRẢ LỜI BÌNH LUẬN DƯỚI VIDEO CỦA CHÍNH KÊNH MÌNH (tư cách chủ kênh, 2026-10-03) =====================
// Luồng: đọc @handle kênh đang đăng nhập (menu ảnh đại diện — ĐO THẬT L-69, như tra_loi_binh_luan) → mở /@handle/videos → lần lượt video MỚI NHẤT
// (so_video) → cuộn tới bình luận (lăn thật, như mọi khối YouTube) → đọc bình luận cấp 1 → chỉ trả lời bình luận của NGƯỜI KHÁC, chưa có phản hồi
// của kênh mình, chưa có trong sổ cái → AI soạn như CHỦ KÊNH → bấm Phản hồi trong ĐÚNG luồng bình luận đó (rủi ro cao, có duyệt).
// Tổng số câu MỖI LƯỢT (so_cau) tính chung cho mọi video: biến đếm dem_cau_kenh (chuỗi "x", mỗi câu sắp gửi thêm một "x") — `when` chặn khi đủ.
// ĐÃ ĐO THẬT (dùng lại): avatar → ytd-multi-page-menu-renderer @handle (L-69); luồng bình luận ytd-comment-thread-renderer, #reply-button-end,
// ytd-comment-reply-dialog-renderer #contenteditable-root / #submit-button button (2026-09-21).
// ĐỐI CHIẾU KHẢO SÁT THẬT 04/10/2026 (YouTube đã đăng nhập; hàng rào tests/unit/dom/khao-sat-0410-hang-rao.test.ts):
//  · lưới video trang kênh: ytd-rich-grid-renderer ytd-rich-item-renderer ĐÃ ĐO; a#video-title-link / #video-title LỆCH (giao diện lockup mới) → ĐÃ SỬA nấc
//    đầu theo yt-lockup-metadata-view-model h3 / a[href*=watch] (kenh_minh_video #204–#206), nấc cũ giữ dự phòng.
//  · luồng bình luận: ytd-comment-thread-renderer > #comment-container > ytd-comment-view-model#comment … a#author-text (chữ "@handle"),
//    yt-attributed-string#content-text, ytd-button-renderer#reply-button-end button "Phản hồi", hộp ytd-comment-reply-dialog-renderer #contenteditable-root
//    + #submit-button button ĐÃ ĐO (video kênh KHÁC: o_tra_loi_da_go #175–#224 — khảo sát kenh_minh_binh_luan dừng vì liên kết video đầu lưới bị ẩn).
//  · khu phản hồi: #replies > ytd-comment-replies-renderer > #collapsed-threads > yt-sub-thread > #more-replies-sub-thread button "N phản hồi" ĐÃ ĐO
//    (shorts #261–#265; KHÔNG còn #more-replies).
//  · VẪN GIẢ ĐỊNH (khảo sát chưa có luồng mà CHỦ KÊNH đã phản hồi): dấu "kênh đã phản hồi" = ảnh #creator-thumbnail trên nút phản hồi lúc thu gọn / huy
//    hiệu ytd-author-comment-badge-renderer / liên kết tác giả /@handle trong khu phản hồi lúc mở. Phản hồi đang thu gọn mà không có các dấu này thì khối
//    KHÔNG biết kênh đã đáp chưa — chỉ sổ cái chặn câu do máy đã gửi.
export const YT_KENH_VIDEO_SPEC = {
  mode: "list",
  list: { describe: "video trên trang Video của kênh mình (mới nhất trước)", ladder: [
    { t: "css", sel: "ytd-rich-grid-renderer ytd-rich-item-renderer" },
    { t: "css", sel: "ytd-grid-video-renderer" },
  ] },
  // Khảo sát thật 04/10 (kenh_minh_video #203–#227): mục là ytd-rich-item-renderer > #content > yt-lockup-view-model > yt-lockup-metadata-view-model >
  // h3[title] > a[href="/watch?v=…"] — KHÔNG còn a#video-title-link / #video-title (trước đây chỉ đọc được nhờ nấc dự phòng h3 / a[href*=watch]).
  // Liên kết ảnh thu nhỏ đầu mục bị ẩn (khảo sát bấm nó báo "phần tử ẩn") → lấy liên kết trong khối tiêu đề trước. Nấc cũ giữ làm dự phòng.
  fields: {
    tieu_de: { sel: "yt-lockup-metadata-view-model h3", attr: "text", alt: ["#video-title", "a#video-title-link", "h3"] },
    lien_ket: { sel: 'yt-lockup-metadata-view-model a[href*="/watch?v="]', attr: "href", alt: ["a#video-title-link", 'a#thumbnail[href*="/watch"]', 'a[href*="/watch?v="]'] },
  },
  item_key: "lien_ket",
};
const YT_KENH_BL_SPEC = {
  mode: "list",
  list: { describe: "bình luận cấp 1 dưới video của kênh mình", ladder: [{ t: "css", sel: "ytd-comment-thread-renderer" }] },
  fields: {
    nguoi: { sel: "#comment #author-text", attr: "text", alt: [":scope > ytd-comment-view-model #author-text", ":scope > ytd-comment-renderer #author-text"] },
    noi_dung: { sel: "#comment #content-text", attr: "text", alt: [":scope > ytd-comment-view-model #content-text", ":scope > ytd-comment-renderer #content-text"] },
    // Kênh mình đã phản hồi (GIẢ ĐỊNH): có giá trị = đã phản hồi → bỏ. {{kenh_minh}} thay lúc chạy (runner render extract_spec).
    kenh_tl_anh: { sel: "#replies #creator-thumbnail img, ytd-comment-replies-renderer #creator-thumbnail img", attr: "src", phan_loai: [{ re: "^https?:", gt: "co" }] },
    kenh_tl_huy_hieu: { sel: "#replies ytd-author-comment-badge-renderer, ytd-comment-replies-renderer ytd-author-comment-badge-renderer", attr: "text", phan_loai: [{ re: "\\S", gt: "co" }] },
    kenh_tl_lien_ket: { sel: '#replies a[href$="/{{kenh_minh}}" i], ytd-comment-replies-renderer a[href$="/{{kenh_minh}}" i]', attr: "href" },
    anh_url: { sel: null, attr: "anh_lon" },
  },
  item_key: "noi_dung",
};
const YT_TRA_LOI_KENH_ACTIONS = [
  { kind: "click", target: { describe: "nút Phản hồi của bình luận này", within: "item", ladder: [
    { t: "css", sel: "#comment #reply-button-end button" },
    { t: "css", sel: "#reply-button-end button" },
  ] } },
  { kind: "type", target: { describe: "ô nhập phản hồi vừa mở trong ĐÚNG luồng bình luận này", within: "item", ladder: [
    { t: "css", sel: "ytd-comment-reply-dialog-renderer #contenteditable-root" },
  ] }, text: "{{item.tra_loi}}", chot: CHOT_VIDEO("video_kenh_url") },
  { kind: "click", target: { describe: "nút Phản hồi (gửi) của ô phản hồi đó", within: "item", ladder: [
    { t: "css", sel: "ytd-comment-reply-dialog-renderer #submit-button button" },
  ] }, chot: CHOT_VIDEO("video_kenh_url") },
];
// Hậu kiểm: câu nằm trong khu PHẢN HỒI của ĐÚNG luồng (luồng thứ _index+1 của danh sách đã đọc) — câu rơi thành bình luận cấp 1 / sang luồng khác
// thì KHÔNG đạt (không tính ô nhập).
const YT_DUOI_DUNG_BL = { t: "locator_visible", target: { describe: "câu trả lời nằm dưới đúng bình luận gốc", ladder: [
  { t: "xpath", xpath: '((//ytd-comment-thread-renderer)[{{ item._index + 1 }}]//*[@id="replies"]//*[@id="content-text"][not(ancestor-or-self::*[@contenteditable="true"])][contains(normalize-space(.), {{ xpath_chu(item.tra_loi) }})])[1]' },
  { t: "xpath", xpath: '((//ytd-comment-thread-renderer)[{{ item._index + 1 }}]//ytd-comment-replies-renderer//*[@id="content-text"][contains(normalize-space(.), {{ xpath_chu(item.tra_loi) }})])[1]' },
] } };
// Không đọc được @handle → bước lỗi "chưa thấy: …" → DỪNG (không đoán: so với handle rỗng là trả lời cả chính mình). Chỉ nhận phần tử có chữ "@…".
export const YT_LAY_KENH_MINH = { extract_spec: { mode: "single", target: { describe: "@handle kênh YouTube đang đăng nhập trong menu ảnh đại diện (không có = chưa đăng nhập / trang đăng nhập / CAPTCHA → dừng)", ladder: [
  { t: "xpath", xpath: '(//ytd-multi-page-menu-renderer//*[@id="channel-handle"][starts-with(normalize-space(.), "@")])[1]' },
  { t: "xpath", xpath: '(//ytd-multi-page-menu-renderer//*[starts-with(normalize-space(text()), "@")])[1]' },
] }, attr: "text", regex: "(@[A-Za-z0-9._-]{3,})" } };

// ===================== ĐỂ TRỐNG ĐỊA CHỈ VIDEO → TỰ TÌM VIDEO (05/10/2026, src/shared/tu-dung.ts BienTheTuTim) =====================
// Bình luận / xem / thích MỘT video mà người dùng không ghi địa chỉ: tìm video theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu — máy điền lúc lắp),
// đọc @handle kênh đang dùng (menu ảnh đại diện, như tra_loi_binh_luan — không đọc được thì không lọc theo kênh), bỏ video của CHÍNH kênh mình, bỏ video
// đã làm (sổ cái của từng việc), [AI chấm liên quan khi có sản phẩm/mục tiêu], làm ĐÚNG MỘT video. Nhiều bước cùng để trống (xem → thích → bình luận) dùng
// CHUNG một lần tìm (chung "yt_video") → thích/bình luận đúng video vừa xem (luật "xem rồi mới làm" của sinhKichBan). Selector = các khối đã đo thật
// (tim_video, binh_luan, luot_video, tra_loi_binh_luan). Không có từ khoá / không có video hợp → không làm gì, lý do rõ.
const VIDEO_TU_TIM_SPEC = {
  ...VIDEO_LIST_SPEC,
  fields: { ...VIDEO_LIST_SPEC.fields, kenh_url: { sel: "ytd-channel-name a", attr: "href", alt: ["#channel-name a"] } },
};
const YT_DK_TU_TIM = "len(trim(tk_video_yt)) > 0";
const YT_TIM_CHUNG = `  - id: tk_video_yt
    template: "{{ts.tu_khoa_tu_tim}}"
    into: tk_video_yt

  - id: tim_video_yt_tu_tim
    when: "${YT_DK_TU_TIM}"
    on: web
    do: "tìm video YouTube theo từ khoá {{tk_video_yt}}"
    expect: "url chứa /results"

  - id: mo_menu_kenh_tu_tim
    when: "${YT_DK_TU_TIM}"
    on: web
    do: "bấm ảnh đại diện kênh để xem @handle kênh đang dùng"
    optional: true
    timeout: 8s

  - id: lay_kenh_tu_tim
    when: "${YT_DK_TU_TIM}"
    on: web
    extract: "@handle kênh đang dùng (menu ảnh đại diện)"
    into: kenh_yt_tu_tim
    optional: true

  - id: dong_menu_kenh_tu_tim
    when: "${YT_DK_TU_TIM}"
    on: web
    do: "đóng menu ảnh đại diện (phím Esc)"
    optional: true

  - id: lay_video_yt_tu_tim
    when: "${YT_DK_TU_TIM}"
    on: web
    extract: "danh sách video: tieu_de, kenh, kenh_url, lien_ket"
    into: ds_video_yt

  - id: loc_video_yt_tu_tim
    when: "${YT_DK_TU_TIM}"
    filter: "len(str(item.lien_ket)) > 0 and not (len(str(kenh_yt_tu_tim)) > 1 and contains(lower(str(item.kenh_url)), lower(str(kenh_yt_tu_tim))))"
    into: ds_video_yt`;
const YT_HOC_TIM_CHUNG = {
  tim_video_yt_tu_tim: { actions: [{ kind: "navigate", url: "{{goc}}results?search_query={{ts_url.tu_khoa_tu_tim}}" }] },
  mo_menu_kenh_tu_tim: { actions: [{ kind: "click", target: { describe: "ảnh đại diện kênh (góc trên phải)", ladder: [{ t: "css", sel: "button#avatar-btn" }, { t: "css", sel: "#avatar-btn" }] } }] },
  lay_kenh_tu_tim: { extract_spec: { mode: "single", target: { describe: "menu ảnh đại diện có @handle", ladder: [{ t: "css", sel: "ytd-multi-page-menu-renderer #channel-handle" }, { t: "css", sel: "ytd-multi-page-menu-renderer" }] }, attr: "text", regex: "(@[A-Za-z0-9._-]{3,})" } },
  dong_menu_kenh_tu_tim: { actions: [{ kind: "press", key: "Escape" }] },
  lay_video_yt_tu_tim: { extract_spec: VIDEO_TU_TIM_SPEC, ghi_khi_rong: "không tìm thấy video nào theo từ khoá — không có gì để làm" },
  loc_video_yt_tu_tim: { ly_do_bo: "video không có liên kết, hoặc là video của CHÍNH kênh đang dùng" },
};
const YT_LY_DO_KHONG_VIDEO = (viec: string) => `Không tìm được video phù hợp để ${viec} lúc này (không có từ khoá/sản phẩm/mục tiêu để tìm, hoặc video tìm được đều của kênh mình / đã ${viec} / không liên quan) — không ${viec} bừa`;
const YT_TU_TIM_BINH_LUAN = {
  thamSo: "bai_url", chung: "yt_video", yamlTim: YT_TIM_CHUNG,
  yamlSteps: `  - id: chon_video_bl_tu_tim
    when: "${YT_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_binh_luan"
    into: ds_video_yt

  - id: soan_video_bl_tu_tim
    for_each: ds_video_yt
    max_items: 1
    when: "${YT_DK_TU_TIM}"
    generate:
      input: "Video '{{item.tieu_de}}' của kênh {{item.kenh}} — viết bình luận cho video này với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 30
      anh: item.anh_url
    into: item.binh_luan

  - id: dang_video_bl_tu_tim
    for_each: ds_video_yt
    max_items: 1
    when: "${YT_DK_TU_TIM} and len(ds_video_yt) > 0"
    ly_do_bo_qua: "${YT_LY_DO_KHONG_VIDEO("bình luận")}"
    on: web
    do: "mở video {{item.lien_ket}}, cuộn tới bình luận, gõ {{item.binh_luan}} vào ô Thêm bình luận rồi bấm Bình luận"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan`,
  learned: { ...YT_HOC_TIM_CHUNG, chon_video_bl_tu_tim: { ly_do_bo: "kênh đã bình luận video này ở lần chạy trước (sổ cái)" }, dang_video_bl_tu_tim: { actions: DANG_ACTIONS, postcondition: DA_GUI("item.lien_ket", "{{item.binh_luan}}") } },
  params: { goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
  chamPhuHop: { danhSach: "ds_video_yt", truong: "tieu_de", truocBuoc: "soan_video_bl_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const YT_TU_TIM_XEM = {
  thamSo: "bai_url", chung: "yt_video", yamlTim: YT_TIM_CHUNG,
  yamlSteps: `  - id: xem_video_yt_tu_tim
    for_each: ds_video_yt
    max_items: 1
    when: "${YT_DK_TU_TIM}"
    on_item_error: skip
    steps:
      - id: mo_video_xem_tu_tim
        on: web
        do: "mở video {{item.lien_ket}} để xem"
        expect: "có trình phát video"
      - id: cho_xem_video_tu_tim
        wait: {{ts.giay_xem}}`,
  learned: { ...YT_HOC_TIM_CHUNG, xem_video_yt_tu_tim: { con: { mo_video_xem_tu_tim: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [YT_CO_TRINH_PHAT] } } } },
  chamPhuHop: { danhSach: "ds_video_yt", truong: "tieu_de", truocBuoc: "xem_video_yt_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const YT_TU_TIM_THICH = {
  thamSo: "bai_url", chung: "yt_video", yamlTim: YT_TIM_CHUNG,
  yamlSteps: `  - id: chon_video_thich_tu_tim
    when: "${YT_DK_TU_TIM}"
    filter: "item.lien_ket not in ledger.da_thich_video"
    into: ds_video_yt

  - id: thich_video_yt_tu_tim
    for_each: ds_video_yt
    max_items: 1
    when: "${YT_DK_TU_TIM} and len(ds_video_yt) > 0"
    ly_do_bo_qua: "${YT_LY_DO_KHONG_VIDEO("thích")}"
    on: web
    do: "mở video {{item.lien_ket}}, bấm Thích nếu chưa thích"
    expect: "nút Thích chuyển sang đã bấm"
    risk: high
    idempotent: unsafe
    timeout: 45s
    on_item_error: skip
    ledger: da_thich_video`,
  learned: { ...YT_HOC_TIM_CHUNG, chon_video_thich_tu_tim: { ly_do_bo: "kênh đã thích video này ở lần chạy trước (sổ cái)" },
    thich_video_yt_tu_tim: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, YT_THICH], postcondition: YT_DA_THICH,
      bo_qua_khi: [{ khi: YT_DA_THICH[0]!, ghi: "video đã được thích từ trước — không bấm (bấm lần hai là bỏ thích)" }] } },
  chamPhuHop: { danhSach: "ds_video_yt", truong: "tieu_de", truocBuoc: "thich_video_yt_tu_tim", maxItemsTu: "__mot_muc", anh: "anh_url" },
};
const YT_MO_TA_DIA_CHI = "Không bắt buộc — để trống thì bot tự tìm video phù hợp theo từ khoá (của bước Tìm / sản phẩm / mục tiêu)";

export const KHOI_YOUTUBE: KhoiMau[] = themChiBaiLienQuan([
  {
    ten: "tim_video",
    moTa: "Tìm video YouTube theo từ khoá rồi lấy danh sách (tieu_de, kenh, luot_xem, lien_ket) vào biến ds_video (bỏ playlist, quảng cáo, Shorts)",
    thamSo: [{ ten: "tu_khoa", moTa: "từ khoá tìm video, tiếng Việt có dấu được; nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá", kieu: "chuoi", batBuoc: true }],
    params: { tu_khoa: { type: "string", default: "{{ts.tu_khoa}}", label: "Từ khoá tìm video" } },
    yamlSteps: `  - id: tim_kiem
    on: web
    do: "tìm video YouTube theo từ khoá {{tu_khoa}}"
    expect: "url chứa /results"

  - id: lay_danh_sach
    on: web
    extract: "danh sách video: tieu_de, kenh, luot_xem, lien_ket"
    into: ds_video
    min_items: 1`,
    learned: {
      tim_kiem: { actions: [{ kind: "navigate", url: "{{goc}}results?search_query={{tu_khoa}}" }] },
      lay_danh_sach: { extract_spec: VIDEO_LIST_SPEC },
    },
  },
  {
    ten: "binh_luan",
    moTa: "Với danh sách ds_video đã có: bỏ video đã bình luận (sổ cái), AI soạn bình luận bám tiêu đề/kênh theo knowledge, mở video, cuộn tới bình luận, gõ và bấm Bình luận (rủi ro cao, ghi sổ cái)",
    thamSo: [{ ten: "so_video", moTa: "số video tối đa sẽ bình luận trong một lần chạy (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 }],
    chamPhuHop: { danhSach: "ds_video", truong: "tieu_de", truocBuoc: "soan", maxItemsTu: "so_video", anh: "anh_url" },
    yamlSteps: `  - id: chon_video
    filter: "item.lien_ket not in ledger.da_binh_luan"

  - id: soan
    for_each: ds_video
    max_items: {{ts.so_video}}
    generate:
      input: "Video '{{item.tieu_de}}' của kênh {{item.kenh}}"
      guide: knowledge
      max_words: 25
      anh: item.anh_url
    into: item.binh_luan

  - id: dang_binh_luan
    for_each: ds_video
    max_items: {{ts.so_video}}
    on: web
    do: "mở video {{item.lien_ket}}, cuộn tới bình luận, gõ {{item.binh_luan}} vào ô Thêm bình luận rồi bấm Bình luận"
    expect: "thấy chữ '{{item.binh_luan}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: DANG_ACTIONS, postcondition: DA_GUI("item.lien_ket", "{{item.binh_luan}}") } },
  },
  {
    ten: "tra_loi_binh_luan",
    moTa: "Mở MỘT video YouTube cho sẵn (tham số video_url), cuộn tới bình luận, đọc các bình luận cấp 1, bỏ bình luận của chính mình (@handle) và đã trả lời (sổ cái), AI soạn câu trả lời theo knowledge rồi bấm Phản hồi và gửi (rủi ro cao). Dùng độc lập với tim_video.",
    chamPhuHop: { danhSach: "ds_bl", truong: "noi_dung", truocBuoc: "soan_tra_loi", maxItemsTu: "so_tra_loi", anh: "anh_url" },
    thamSo: [
      { ten: "so_tra_loi", moTa: "số bình luận tối đa sẽ trả lời trong một lần chạy (1-3)", kieu: "so", batBuoc: true, min: 1, max: 3 },
      { ten: "video_url", moTa: "liên kết video YouTube cần chăm sóc bình luận (người dùng cho); để trống nếu chưa biết — người dùng sẽ điền lúc chạy", kieu: "chuoi", macDinh: "https://www.youtube.com/" },
      { ten: "tai_khoan", moTa: "@handle kênh YouTube của mình — thường bỏ trống: máy tự đọc @handle kênh đang dùng (menu ảnh đại diện) để KHÔNG trả lời chính mình; chỉ điền khi người dùng nói rõ handle", kieu: "chuoi", macDinh: "" },
    ],
    params: {
      video_url: { type: "string", default: "{{ts.video_url}}", label: "Liên kết video cần trả lời bình luận" },
      tai_khoan: { type: "string", default: "{{ts.tai_khoan}}", label: "@handle kênh của mình — bỏ trống: máy tự đọc kênh đang dùng" },
    },
    yamlSteps: `  - id: mo_binh_luan
    on: web
    do: "mở video {{video_url}} rồi cuộn tới khu bình luận"
    expect: "url chứa watch"

  - id: mo_menu_kenh
    on: web
    do: "bấm ảnh đại diện kênh để xem @handle kênh đang dùng"
    optional: true
    timeout: 8s

  - id: lay_tai_khoan
    on: web
    extract: "@handle kênh đang dùng (menu ảnh đại diện)"
    into: tai_khoan_trang
    optional: true

  - id: dong_menu_kenh
    on: web
    do: "đóng menu ảnh đại diện (phím Esc)"
    optional: true

  - id: lay_binh_luan
    on: web
    extract: "bình luận cấp 1: nguoi, noi_dung, thich"
    into: ds_bl
    min_items: 1

  - id: loc_binh_luan
    filter: "(len(tai_khoan) > 0 or len(tai_khoan_trang) > 0) and item.nguoi != tai_khoan and item.nguoi != tai_khoan_trang and item.noi_dung not in ledger.da_tra_loi"

  - id: soan_tra_loi
    for_each: ds_bl
    max_items: {{ts.so_tra_loi}}
    generate:
      input: "Bình luận của {{item.nguoi}} dưới video: {{item.noi_dung}} — (bạn là một NGƯỜI XEM KHÁC, KHÔNG phải chủ video/kênh: đáp lại như đang cùng xem, không cảm ơn hay hứa hẹn thay chủ kênh)"
      guide: knowledge
      max_words: 25
      anh: item.anh_url
    into: item.tra_loi

  - id: gui_tra_loi
    for_each: ds_bl
    max_items: {{ts.so_tra_loi}}
    on: web
    do: "bấm Phản hồi của bình luận này, gõ {{item.tra_loi}} vào ô trả lời rồi bấm Phản hồi"
    expect: "thấy chữ '{{item.tra_loi}}'"
    risk: high
    timeout: 60s
    on_item_error: skip
    ledger: da_tra_loi`,
    learned: {
      // Hậu kiểm mở: đúng video (URL còn chứa video_url — YouTube có thể tự chuyển video khi hết) và bình luận đã tải (có thread).
      mo_binh_luan: { actions: MO_BINH_LUAN_ACTIONS("{{video_url}}"), postcondition: [{ t: "url_contains", s: "{{video_url}}" }, { t: "dom_exists", sel: "ytd-comment-thread-renderer" }] },
      // L-69: đo thật (test-that/xt/xt-lib.mjs kiemKenhYt, 2026-10-01): bấm button#avatar-btn → ytd-multi-page-menu-renderer có "@handle".
      mo_menu_kenh: { actions: [{ kind: "click", target: { describe: "ảnh đại diện kênh (góc trên phải)", ladder: [{ t: "css", sel: "button#avatar-btn" }, { t: "css", sel: "#avatar-btn" }] } }] },
      lay_tai_khoan: { extract_spec: { mode: "single", target: { describe: "menu ảnh đại diện có @handle", ladder: [{ t: "css", sel: "ytd-multi-page-menu-renderer #channel-handle" }, { t: "css", sel: "ytd-multi-page-menu-renderer" }] }, attr: "text", regex: "(@[A-Za-z0-9._-]{3,})" } },
      dong_menu_kenh: { actions: [{ kind: "press", key: "Escape" }] },
      lay_binh_luan: { extract_spec: COMMENT_LIST_SPEC },
      gui_tra_loi: { actions: TRA_LOI_ACTIONS, postcondition: DA_GUI("video_url", "{{item.tra_loi}}") },
    },
  },
  {
    ten: "thich_binh_luan",
    moTa: "Thích MỘT bình luận cụ thể dưới một video (tìm theo chữ nó chứa) — đội nhiều nick cùng đỡ một bình luận. Bấm lần hai là BỎ thích nên sổ cái ghi ngay khi bấm, không bao giờ bấm lại.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ video", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bình luận cần thích", kieu: "chuoi", batBuoc: true },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bình luận" } },
    yamlSteps: `  - id: thich_bl
    on: web
    do: "mở video {{bai_url}}, bấm Thích ở bình luận có chữ {{chu_binh_luan}}"
    expect: "nút Thích của bình luận đó ở trạng thái đã bấm"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_thich`,
    learned: {
      thich_bl: { actions: YT_THICH_ACTIONS, postcondition: [{ t: "locator_visible", target: { describe: "nút Thích đã bấm của bình luận đó", ladder: [
        { t: "xpath", xpath: `(${YT_LUONG}//*[@id="like-button"]//button[@aria-pressed="true"])[1]` },
      ] } }] },
    },
  },
  {
    ten: "tra_loi_mot_binh_luan",
    moTa: "Trả lời ĐÚNG một bình luận dưới video (tìm theo chữ): AI soạn câu như người xem khác. Rủi ro cao — có cổng duyệt, sửa được câu.",
    thamSo: [
      { ten: "bai_url", moTa: "địa chỉ video", kieu: "chuoi", batBuoc: true },
      { ten: "chu_binh_luan", moTa: "một đoạn chữ có trong bình luận cần trả lời", kieu: "chuoi", batBuoc: true },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" }, chu_binh_luan: { type: "string", default: "{{ts.chu_binh_luan}}", label: "Chữ trong bình luận" } },
    yamlSteps: `  - id: soan_tra_loi
    generate:
      input: "Trả lời bình luận này như một người xem khác, không phải chủ kênh: {{chu_binh_luan}}"
      guide: knowledge
      max_words: 30
    into: cau_tra_loi

  - id: gui_tra_loi
    on: web
    do: "mở video {{bai_url}}, bấm Phản hồi ở bình luận có chữ {{chu_binh_luan}}, gõ {{cau_tra_loi}} rồi gửi"
    expect: "thấy chữ '{{cau_tra_loi}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_tra_loi_bl`,
    learned: { gui_tra_loi: { actions: YT_TRA_LOI_MOT_ACTIONS, postcondition: DA_GUI("bai_url", "{{cau_tra_loi}}") } },
  },
  {
    ten: "binh_luan_mot_bai",
    moTa: "Bình luận vào MỘT video: có địa chỉ (bai_url) → đúng video đó (nhiều nick cùng vào một video, mỗi nick một góc nhìn); ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bước Tìm / sản phẩm / mục tiêu), bỏ video của chính kênh mình và video đã bình luận, có sản phẩm/mục tiêu thì AI chấm video liên quan; không có video hợp → không làm gì. Rủi ro cao — có cổng duyệt.",
    thamSo: [
      { ten: "bai_url", moTa: `địa chỉ video — ${YT_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
      { ten: "goc_nhin", moTa: "góc nhìn của nick này, ví dụ: người mới / đã dùng lâu / hỏi giá", kieu: "chuoi", batBuoc: false },
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" }, goc_nhin: { type: "string", default: "{{ts.goc_nhin}}", label: "Góc nhìn của nick này" } },
    yamlSteps: `  - id: soan
    generate:
      input: "Viết bình luận cho video này với góc nhìn: {{goc_nhin}}"
      guide: knowledge
      max_words: 30
    into: binh_luan

  - id: dang_binh_luan
    on: web
    do: "mở video {{bai_url}}, bấm Thêm bình luận, gõ {{binh_luan}} rồi bấm Bình luận"
    expect: "thấy chữ '{{binh_luan}}'"
    risk: high
    idempotent: unsafe
    timeout: 60s
    ledger: da_binh_luan`,
    learned: { dang_binh_luan: { actions: YT_BINH_LUAN_MOT_ACTIONS, postcondition: DA_GUI("bai_url", "{{binh_luan}}") } },
    tuTim: YT_TU_TIM_BINH_LUAN,
  },
  // ---------- như người (2026-10-01) ----------
  {
    ten: "xem_video",
    moTa: "Mở MỘT video (hoặc Short) và ở lại xem số giây cho sẵn, như người trước khi thích/bình luận. Có địa chỉ → đúng video đó; ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bỏ video của chính kênh mình; có sản phẩm/mục tiêu thì AI chấm liên quan) — các bước Thích/Bình luận để trống phía sau làm đúng video vừa xem. Chỉ xem.",
    thamSo: [
      { ten: "bai_url", moTa: `địa chỉ video (https://www.youtube.com/watch?v=… hoặc /shorts/…) — ${YT_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false },
      YT_TS_GIAY_XEM,
    ],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" } },
    yamlSteps: `  - id: mo_video_xem
    on: web
    do: "mở video {{bai_url}} để xem"
    expect: "có trình phát video"

  - id: xem_video_yt
    wait: {{ts.giay_xem}}`,
    learned: { mo_video_xem: { actions: [{ kind: "navigate", url: "{{bai_url}}" }], postcondition: [YT_CO_TRINH_PHAT] } },
    tuTim: YT_TU_TIM_XEM,
  },
  {
    ten: "thich_video",
    moTa: "Thích MỘT video hoặc Short, chỉ khi chưa thích. Có địa chỉ → đúng video đó; ĐỂ TRỐNG → bot TỰ TÌM một video theo từ khoá của kịch bản (bỏ video của chính kênh mình, video đã thích; có sản phẩm/mục tiêu thì AI chấm liên quan) — đặt sau bước Xem để trống thì thích đúng video vừa xem. Rủi ro cao — có duyệt; sổ cái chống bấm lần hai.",
    thamSo: [{ ten: "bai_url", moTa: `địa chỉ video — ${YT_MO_TA_DIA_CHI}`, kieu: "chuoi", batBuoc: false }],
    params: { bai_url: { type: "string", default: "{{ts.bai_url}}", label: "Địa chỉ video" } },
    yamlSteps: `  - id: thich_video_yt
    on: web
    do: "mở video {{bai_url}}, bấm Thích nếu chưa thích"
    expect: "nút Thích chuyển sang đã bấm"
    risk: high
    idempotent: unsafe
    timeout: 45s
    ledger: da_thich_video`,
    learned: { thich_video_yt: { actions: [{ kind: "navigate", url: "{{bai_url}}" }, YT_THICH], postcondition: YT_DA_THICH } },
    tuTim: YT_TU_TIM_THICH,
  },
  {
    ten: "luot_video",
    moTa: "Với ds_video vừa tìm: mở từng video, xem số giây cho sẵn, thỉnh thoảng Thích (tỉ lệ nhỏ, có duyệt). Đặt bước Bình luận SAU bước này.",
    thamSo: [
      { ten: "so_video", moTa: "số video lướt xem tối đa (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      YT_TS_GIAY_XEM,
      YT_TS_TI_LE_THICH,
    ],
    params: { ti_le_thich: { type: "string", default: "{{ts.ti_le_thich}}", label: "Tỉ lệ % video được thích khi lướt (0-30)" } },
    yamlSteps: `  - id: luot_xem_video
    for_each: ds_video
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: mo_video_luot
        on: web
        do: "mở video {{item.lien_ket}} để xem"
        expect: "có trình phát video"
      - id: xem_video_luot
        wait: {{ts.giay_xem}}
      - id: thich_video_luot
        when: "${YT_DK_THICH_LUOT}"
        ly_do_bo_qua: "Lần này chưa tới lượt thích video nào (tỉ lệ thích {{ts.ti_le_thich}}%) — chỉ lướt xem"
        on: web
        do: "mở lại video {{item.lien_ket}}, bấm Thích nếu chưa thích"
        expect: "nút Thích chuyển sang đã bấm"
        risk: high
        idempotent: unsafe
        timeout: 45s
        ledger: da_thich_video`,
    learned: {
      // Bước con của vòng xem: phần đã học nằm dưới bước cha (con) — xem gopDaHoc trong shared/tu-dung.ts.
      luot_xem_video: { con: {
        mo_video_luot: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }], postcondition: [YT_CO_TRINH_PHAT] },
        // MỞ LẠI đúng video trước khi bấm (như TikTok, tt-khoi.ts): trong lúc xem, YouTube có thể TỰ chuyển sang video khác (SPA, tự phát
        // video kế) → bấm Thích trên trang đang hiện là thích nhầm video (E2E dieu-huong-cham DH3). Có navigate thì hậu kiểm 'đã thích' cũng
        // kiểm trên cả trang video — trước đây bị gói trong mục #N của danh sách KẾT QUẢ TÌM (không còn trên trang video) → luôn báo hụt.
        thich_video_luot: { actions: [{ kind: "navigate", url: "{{item.lien_ket}}" }, YT_THICH], postcondition: YT_DA_THICH },
      } },
    },
  },
  {
    ten: "luot_shorts",
    moTa: "Lướt Shorts: xem mỗi Short số giây cho sẵn rồi sang Short kế. Chỉ xem (rủi ro thấp) — giữ nick hoạt động tự nhiên.",
    thamSo: [
      { ten: "so_video", moTa: "số Short lướt xem (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
      { ...YT_TS_GIAY_XEM, moTa: "số giây xem mỗi Short (3-120)", max: 120, macDinh: "15" },
    ],
    yamlSteps: `  - id: mo_shorts
    on: web
    do: "mở trang Shorts"
    expect: "có trình phát Shorts"

  - id: luot_shorts_vong
    for_each: "[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: xem_short
        wait: {{ts.giay_xem}}
      - id: sang_short_ke
        on: web
        do: "bấm sang Short kế tiếp"`,
    learned: {
      mo_shorts: { actions: [{ kind: "navigate", url: "{{goc}}shorts" }], postcondition: [{ t: "dom_exists", sel: "ytd-shorts" }] },
      luot_shorts_vong: { con: { sang_short_ke: { actions: [{ kind: "click", target: { describe: "nút Video tiếp theo của Shorts", ladder: [{ t: "css", sel: "ytd-shorts #navigation-button-down button" }] } }] } } },
    },
  },
  {
    ten: "nghi",
    moTa: "Nghỉ một lúc như người thật, không làm gì trên trang — đặt GIỮA hai việc.",
    thamSo: [{ ten: "giay_nghi", moTa: "số giây nghỉ (5-1800)", kieu: "so", min: 5, max: 1800, macDinh: "60" }],
    yamlSteps: `  - id: nghi
    wait: {{ts.giay_nghi}}`,
    learned: {},
  },
  // ---------- 2026-10-03: trả lời bình luận dưới video của CHÍNH kênh mình ----------
  {
    ten: "tra_loi_binh_luan_kenh_minh",
    moTa: "Trả lời bình luận dưới các video CỦA CHÍNH KÊNH MÌNH (tư cách chủ kênh): máy tự đọc @handle kênh đang đăng nhập, mở trang Video của kênh, lần lượt so_video video mới nhất, đọc bình luận cấp 1, chỉ trả lời bình luận của NGƯỜI KHÁC chưa được kênh phản hồi (bỏ bình luận của chính kênh, đã trả lời — sổ cái), AI soạn câu đáp như chủ kênh rồi bấm Phản hồi (rủi ro cao, có duyệt). Tối đa so_cau câu mỗi lượt cho mọi video. Dùng độc lập, không cần tìm kiếm.",
    thamSo: [
      { ten: "so_video", moTa: "số video mới nhất của kênh sẽ xem bình luận (1-5)", kieu: "so", batBuoc: true, min: 1, max: 5 },
      { ten: "so_cau", moTa: "số câu trả lời tối đa MỖI LƯỢT chạy, tính chung mọi video (1-10)", kieu: "so", batBuoc: true, min: 1, max: 10 },
    ],
    yamlSteps: `  - id: mo_trang_kenh_minh
    on: web
    do: "mở YouTube để đọc kênh đang dùng"
    expect: "trang YouTube"

  - id: mo_menu_kenh_minh
    on: web
    do: "bấm ảnh đại diện kênh (góc trên phải) để xem @handle kênh đang dùng"
    expect: "menu ảnh đại diện mở"
    timeout: 20s

  - id: lay_kenh_minh
    on: web
    extract: "@handle kênh đang đăng nhập (menu ảnh đại diện)"
    into: kenh_minh
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_kenh_minh
    on: web
    do: "đóng menu ảnh đại diện (phím Esc)"
    optional: true

  - id: mo_video_kenh_minh
    on: web
    do: "mở trang Video của kênh {{kenh_minh}}"
    expect: "url chứa /videos"

  - id: lay_video_kenh_minh
    on: web
    extract: "video của kênh mình, mới nhất trước: tieu_de, lien_ket"
    into: ds_video_kenh
    timeout: 20s

  - id: dem_cau_kenh
    template: "x"
    into: dem_cau_kenh

  - id: tra_loi_video_kenh
    for_each: ds_video_kenh
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: mo_bl_video_kenh
        on: web
        do: "mở video {{item.lien_ket}} của kênh mình rồi cuộn tới khu bình luận"
        expect: "trang đúng video, có khu bình luận"
      - id: ghi_video_kenh
        template: "{{item.lien_ket}}"
        into: video_kenh_url
      - id: lay_bl_video_kenh
        on: web
        extract: "bình luận cấp 1: nguoi, noi_dung, kenh_tl_anh, kenh_tl_huy_hieu, kenh_tl_lien_ket"
        into: item.ds_bl
        timeout: 15s
      - id: tra_loi_bl_kenh
        for_each: item.ds_bl
        max_items: {{ts.so_cau}}
        when: "len(kenh_minh) > 1 and len(dem_cau_kenh) <= {{ts.so_cau}} and len(str(item.noi_dung)) > 0 and lower(str(item.nguoi)) != lower(kenh_minh) and not item.kenh_tl_anh and not item.kenh_tl_huy_hieu and not item.kenh_tl_lien_ket and (video_kenh_url + '/' + item.noi_dung) not in ledger.da_tra_loi_kenh"
        on_item_error: skip
        steps:
          - id: soan_tra_loi_kenh
            generate:
              input: "{{ str(item.nguoi) }} bình luận dưới video của kênh bạn: {{item.noi_dung}} — (bạn là CHỦ KÊNH đăng video này: đáp lại người xem như chủ kênh — cảm ơn / giải đáp đúng điều họ nói, ngắn gọn, thân thiện; không hứa điều video không có, không chèn liên kết)"
              guide: knowledge
              max_words: 30
              anh: item.anh_url
            into: item.tra_loi
          - id: dem_cau_kenh_them
            template: "{{dem_cau_kenh}}x"
            into: dem_cau_kenh
          - id: gui_tra_loi_kenh
            on: web
            do: "bấm Phản hồi của bình luận này, gõ {{item.tra_loi}} vào ô phản hồi rồi bấm Phản hồi"
            expect: "câu trả lời hiện dưới đúng bình luận gốc"
            risk: high
            timeout: 60s
            on_item_error: skip
            ledger: da_tra_loi_kenh`,
    learned: {
      mo_trang_kenh_minh: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
      // L-69 (đo thật): button#avatar-btn → ytd-multi-page-menu-renderer. Không có nút (chưa đăng nhập: chỉ có nút "Đăng nhập") → bước lỗi, DỪNG.
      mo_menu_kenh_minh: { actions: [{ kind: "click", target: { describe: "ảnh đại diện kênh (góc trên phải) — chưa đăng nhập YouTube thì không có nút này", ladder: [{ t: "css", sel: "button#avatar-btn" }, { t: "css", sel: "#avatar-btn" }] } }], postcondition: [{ t: "dom_exists", sel: "ytd-multi-page-menu-renderer" }] },
      lay_kenh_minh: YT_LAY_KENH_MINH,
      dong_menu_kenh_minh: { actions: [{ kind: "press", key: "Escape" }] },
      mo_video_kenh_minh: { actions: [{ kind: "navigate", url: "{{goc}}{{kenh_minh}}/videos" }], postcondition: [{ t: "url_contains", s: "{{kenh_minh}}/videos" }] },
      // L-97/L-106: danh sách CỦA MÌNH rỗng = không có việc (lần chạy sạch, câu dễ hiểu), không phải "có thể chưa đăng nhập" (đã kiểm đăng nhập ở bước đọc kênh).
      lay_video_kenh_minh: { extract_spec: YT_KENH_VIDEO_SPEC, khong_viec_khi_rong: "Kênh của bạn chưa có video nào — không có bình luận nào để trả lời" },
      tra_loi_video_kenh: { con: {
        // Hậu kiểm mở: ĐÚNG video (mã video) + khu bình luận đã có (#comments) — video 0 bình luận vẫn đạt (bước đọc ra 0 mục, 0 việc).
        mo_bl_video_kenh: { actions: MO_BINH_LUAN_ACTIONS("{{item.lien_ket}}"), postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, { t: "dom_exists", sel: "#comments" }] },
        lay_bl_video_kenh: { extract_spec: YT_KENH_BL_SPEC, khong_viec_khi_rong: "Kênh chưa có bình luận nào trên các video vừa xem — không có gì để trả lời lúc này" },
        tra_loi_bl_kenh: { con: {
          gui_tra_loi_kenh: { actions: YT_TRA_LOI_KENH_ACTIONS, postcondition: [...DA_GUI("video_kenh_url", "{{item.tra_loi}}"), YT_DUOI_DUNG_BL] },
        } },
      } },
    },
  },
]);
